import Accordion from "../../../../components/Containers/Accordion";
import { useTranslationApp } from "../../../../lib/i18next";
import { WHY_THESE_RECOMMENDED_SETTINGS } from "../../../../i18n/keysTranslations";
import { useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import TypingText from "../../../../components/Texts/TypingText";
import { useFormContext } from "react-hook-form";
import { useState } from "react";
import ModalViewAction from "./ModalViewAction";
import { BOX_SHADOW_THEME, INPUT_COLOR_BORDER } from "../../../../utils/colors";
import { BORDER_RADIUS } from "../../../../utils/constants";

const ReasoningContainer = ({
  platform,
  onCallbackFinishReasoning = () => { },
}) => {
  const [selectedAction, setSelectedAction] = useState(null);
  const { watch, getValues } = useFormContext();

  const { t } = useTranslationApp();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const platformData = watch(`platformsData.${platform}`);
  const reasoningPlatform = platformData?.reasoning;
  const oldReasoning = getValues("reasoning");

  const reasoning = oldReasoning || reasoningPlatform;

  const commonSxAccordion = {
    backgroundColor: "fields.background",
    borderRadius: `${BORDER_RADIUS * 4}px !important`,
    border: `1px solid ${INPUT_COLOR_BORDER}`,
    boxShadow: BOX_SHADOW_THEME,
    "::before": {
      backgroundColor: "transparent",
    },
    m: "0 !important",
    mb: "4px !important",
  };

  if (!reasoning) {
    return null;
  }
  return (
    <>
      <Accordion
        initialValue={true}
        title={t(WHY_THESE_RECOMMENDED_SETTINGS)}
        variantTitle={isMobile ? "body1" : "h6"}
        sx={{ ...commonSxAccordion }}
        sxTitle={{
          fontWeight: 600,
        }}
        sxContainerTitle={{
          ".MuiAccordionSummary-content": {
            display: "flex",
            alignItems: "center",
            flexDirection: {
              xs: "column",
              sm: "row",
            },
          },
          ".MuiAccordionSummary-expandIconWrapper": {},
          pt: 0,
        }}
        minHeight={64}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            height: "auto",
          }}
        >
          {reasoning ? (
            <TypingText
              text={reasoning}
              onCallbackFinish={() => {
                onCallbackFinishReasoning();
              }}
              sx={{
                height: 200,
              }}
            />
          ) : null}
        </Box>
      </Accordion>
      {selectedAction && (
        <ModalViewAction
          modalOpen={Boolean(selectedAction)}
          platform={platform}
          action={selectedAction}
          actionIndex={selectedAction.index}
          onCloseModal={() => setSelectedAction(null)}
        />
      )}
    </>
  );
};

export default ReasoningContainer;
